import React from 'react';
import { InsightsMobileContent } from '@/experiences/sales-portal/domain/insights/containers/insights-mobile-content';
import { SalesHubShellTemplate } from '@/experiences/sales-portal/templates/sales-hub-shell-template';

interface Props {
  supplierUUID: string;
}

/**
 * The Insights ("For You") screen for phones: the alert feed in a single
 * column, without the desktop screen's insight-card side column.
 *
 * Reached through {@link InsightsScreenWrapper}, never registered directly.
 */
export const InsightsMobileScreen: React.FC<Props> = ({ supplierUUID }) => (
  <SalesHubShellTemplate>
    <InsightsMobileContent supplierUUID={supplierUUID} />
  </SalesHubShellTemplate>
);
